<script setup>
  import {onBeforeMount, ref, watch} from "vue";

  import ComponentInput from "@components/Inputs/Input.vue";
  import {MedCheckbox, MedFormField, MedLabel} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "PatientinputComponentMasterdataCarerFields",
  });

  const props = defineProps({
    form: {
      type: Object,
      required: true,
    },
  });

  const showAdditionalFields = ref(false);

  const nursingHomeKeys = [
    "nursing_home_name",
    "nursing_home_street",
    "nursing_home_zip",
    "nursing_home_city",
    "nursing_home_ward",
    "nursing_home_room",
  ];

  watch(
    () => showAdditionalFields.value,
    (newValue) => {
      if (newValue === false) {
        nursingHomeKeys.forEach((key) => {
          props.form.masterdata[key] = null;
        });
      }
    },
  );

  onBeforeMount(() => {
    showAdditionalFields.value = Object.entries(props.form.masterdata).some(
      ([key, value]) => nursingHomeKeys.includes(key) && !!value,
    );
  });
</script>

<template>
  <ComponentInput
    v-model="form.masterdata.doc_name"
    type="text"
    autocomplete="off"
    label="Behandelnder Arzt / behandelnde Ärztin"
    large
    :test-id="getTestId('carer-fields-doc-name')"
  />

  <ComponentInput
    v-model="form.masterdata.nursing_home_carer"
    type="text"
    autocomplete="off"
    label="Zuständige Pflegefachkraft"
    large
    :test-id="getTestId('carer-fields-nursing-home-carer')"
  />

  <MedFormField orientation="horizontal" size="mobile">
    <MedCheckbox
      v-model="showAdditionalFields"
      variant="primary"
      :data-test="getTestId('carer-fields-show-additional-checkbox')"
    />
    <MedLabel clickable>Weitere Angaben zur Einrichtung (optional)</MedLabel>
  </MedFormField>

  <template v-if="showAdditionalFields">
    <ComponentInput
      v-model="form.masterdata.nursing_home_name"
      type="text"
      autocomplete="off"
      label="Name der Einrichtung"
      large
      :test-id="getTestId('carer-fields-nursing-home-name')"
    />

    <ComponentInput
      v-model="form.masterdata.nursing_home_street"
      type="text"
      autocomplete="off"
      label="Straße, Hausnr."
      large
      :test-id="getTestId('carer-fields-nursing-home-street')"
    />

    <ComponentInput
      v-model="form.masterdata.nursing_home_zip"
      type="text"
      autocomplete="off"
      label="Postleitzahl"
      large
      :test-id="getTestId('carer-fields-nursing-home-zip')"
    />

    <ComponentInput
      v-model="form.masterdata.nursing_home_city"
      type="text"
      autocomplete="off"
      label="Ort"
      large
      :test-id="getTestId('carer-fields-nursing-home-city')"
    />

    <ComponentInput
      v-model="form.masterdata.nursing_home_ward"
      type="text"
      autocomplete="off"
      label="Station"
      large
      :test-id="getTestId('carer-fields-nursing-home-ward')"
    />

    <ComponentInput
      v-model="form.masterdata.nursing_home_room"
      type="text"
      autocomplete="off"
      label="Raum"
      large
      :test-id="getTestId('carer-fields-nursing-home-room')"
    />
  </template>
</template>
